export function buildGoogleCalendarLink({ title, description, startDate, durationMinutes = 60, attendees = [] }) {
  const start = new Date(startDate);
  const end = new Date(start.getTime() + durationMinutes * 60000);
  const fmt = (d) => d.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: title || "Meeting",
    dates: `${fmt(start)}/${fmt(end)}`,
    details: `${description || ""}\n\nTip: click "Add Google Meet video conferencing" inside the event to generate a Meet link.`,
  });
  if (attendees.length) params.set("add", attendees.join(","));
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}
